import { Badge, Box, Group, Stack, Text } from '@mantine/core';
import { getEnumColor, getEnumLabel } from '../../../../../utils/enumUtils';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SHORT_LINK_STATUSES } from '../../../../common/enums/enums';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';

const StatusCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;

    const statusLabel =
        getEnumLabel(SHORT_LINK_STATUSES, rowData.status) || 'Unknown';
    const statusColor = getEnumColor(SHORT_LINK_STATUSES, rowData.status);

    const showLoader = {
        Provisioning: true,
        Propogating: true,
    };

    return (
        <Badge
            size={'sm'}
            color={statusColor}>
            {statusLabel}
            {showLoader[rowData.status] ? (
                <FontAwesomeIcon
                    spin
                    icon={faSpinnerThird}
                />
            ) : null}
        </Badge>
    );
};

const StatusColumn = () => ({
    accessorKey: 'status',
    header: 'Status',
    size: 2,
    minSize: 100,
    Cell: ({ cell }) => <StatusCell cell={cell} />,
});
export default StatusColumn;
